/**
 * API工具函数
 */

/**
 * @description 获取API基础URL
 */
export function getBaseURL() {
  let baseURL = process.env.VUE_APP_API_BASE_URL || '/api'
  if (!baseURL.endsWith('/')) {
    baseURL += '/'
  }
  return baseURL
}

/**
 * @description 错误消息处理
 */
export function getErrorMessage(msg) {
  if (typeof msg === 'string') {
    return msg
  }
  if (typeof msg === 'object') {
    if (msg.code === 'token_not_valid') {
      return '登录已过期，请重新登录！'
    }
    if (msg.code === 'user_not_found') {
      return '用户无效，请重新登录！'
    }
    return Object.values(msg).join(', ')
  }
  if (Array.isArray(msg)) {
    return msg.join(', ')
  }
  return String(msg)
}

/**
 * @description 存储token
 */
export function setToken(token) {
  localStorage.setItem('access_token', token)
}

/**
 * @description 获取token
 */
export function getToken() {
  return localStorage.getItem('access_token')
}

/**
 * @description 移除token
 */
export function removeToken() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('user_info')
}

/**
 * @description 存储refresh token
 */
export function setRefreshToken(token) {
  localStorage.setItem('refresh_token', token)
}

/**
 * @description 获取refresh token
 */
export function getRefreshToken() {
  return localStorage.getItem('refresh_token')
}

/**
 * @description 存储用户信息
 */
export function setUserInfo(userInfo) {
  localStorage.setItem('user_info', JSON.stringify(userInfo))
}

/**
 * @description 获取用户信息
 */
export function getUserInfo() {
  const userInfo = localStorage.getItem('user_info')
  return userInfo ? JSON.parse(userInfo) : null
}
